import React from 'react';
import { Button, Box, Typography } from '@mui/material';
import { Google } from '@mui/icons-material';

const GoogleSignInButton = ({ onClick, disabled = false, fullWidth = false, variant = 'outlined', showTooltip = false }) => {
  return (
    <Button
      variant={variant}
      onClick={onClick}
      disabled={disabled}
      fullWidth={fullWidth}
      startIcon={<Google />}
      title={disabled ? "Google OAuth not configured. Please set up Google Cloud Console credentials." : ""}
      sx={{
        backgroundColor: variant === 'contained' ? '#4285f4' : 'transparent',
        color: variant === 'contained' ? 'white' : '#4285f4',
        borderColor: '#4285f4',
        '&:hover': {
          backgroundColor: variant === 'contained' ? '#3367d6' : 'rgba(66, 133, 244, 0.04)',
          borderColor: '#3367d6',
        },
        '&:disabled': {
          backgroundColor: 'rgba(0, 0, 0, 0.12)',
          color: 'rgba(0, 0, 0, 0.26)',
          borderColor: 'rgba(0, 0, 0, 0.12)',
        },
        textTransform: 'none',
        fontWeight: 500,
        py: 1.5,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Google sx={{ fontSize: 20 }} />
        <Typography variant="body1">
          {disabled ? "Google Sign-in (Not Configured)" : "Continue with Google"}
        </Typography>
      </Box>
    </Button>
  );
};

export default GoogleSignInButton;
